import React from 'react';
import { Grid, TextBox } from 'fw/forms';
import { Col, Modal, Row, Button } from 'react-bootstrap';
import * as Block from 'fw/globals/Block';
import * as API from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';
import * as Formatter from 'fw/components/formatter/Formatter';
import Loading from 'layouts/public/loading/Loading';

class SponsorSelectionPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            searchText: props.searchText,
            selectedSponsorId: null,
            items: []
        }
    }

    load = () => {
        if (!this.state.searchText)
        {
            Notifications.error("Please provide a search criteria.");
            return;
        }

		Block.block();

        let rq = {
            searchText: this.state.searchText
        };
        
        API.Admin.get('/paypalInvoice/sponsorSearch',
			rq,
			{
				success: (r) => {
					this.setState({
						items: r.data.items,
                        selectedSponsorId: null
					});
					Block.unblock();
				},
				error: (r) => {
					this.props.onError(r.error);
					Block.unblock();
				},
			},
			{ block: false }
		);
	};

    componentWillReceiveProps(nextProps) {
        if (nextProps.visible !== this.props.visible || 
			nextProps.searchText !== this.props.searchText)
        {
            this.setState({
                visible: nextProps.visible,
                selectedSponsorId: null,
                items: [],
                searchText: nextProps.searchText
            });

            this.load();
        }
    }

    close = () => {
        this.setState({
            visible: false,
            selectedSponsorId: null
        }, function () {
            this.props.onClose();
        });
    }

    getBusy = () => {
        this.setState({
            busy: true
        });
    }

    save = () => {
        if (!this.state.selectedSponsorId)
        {
            Notifications.error("Please select a Corporate Member.");
            return;
        }
        
		this.getBusy();
		const rq = {
			paypalInvoiceId: this.props.paypalInvoiceId,
			sponsorId: this.state.selectedSponsorId
		};

		API.Sponsor.post('/sponsorSetup/createSponsorHistoryFromPaypalInvoice',
			rq,
			{
				success: (r) => {
                    Notifications.success(r.message);
                    var url = `/admin/sponsorSetup/${r.data.sponsorId}/sponsorHistory`;
                    window.location.href = url;
				},
				error: (r) => {
                    Notifications.error(r.error.errorMessage);
					Block.unblock();
				},
			},
			{ block: false }
		);
	};

    onSearchTextChange = (value) => {
        this.setState({
            searchText: value
        });
    }

    onGridChange = (value) => {
        this.setState({
            selectedSponsorId: value,
        });
    }

    render() {
        const columns = [
            { key: 'sponsorName', name: 'Corporate Member Name', sortable: false },
            { key: 'active', name: 'Active', formatter: Formatter.Check, cellClass: "text-center" }
        ];

        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-60w">
                <Modal.Header>
                    <h3>Search Corporate Member – <small>Please select a member to assign the invoice to their history.</small></h3>
                </Modal.Header>
                <Modal.Body>
                {this.state.busy ?
                    <Loading />
                :
                    <React.Fragment>
                        <Row>
                            <Col xs={8}>
                                <TextBox 
                                    placeholder="Corporate Member Name" 
                                    value={this.state.searchText}
                                    onChange={this.onSearchTextChange} />
                            </Col>
                            <Col xs={4}>
                                <Button id="btnSearch" className="pull-right" onClick={this.load} bsStyle="primary">Search</Button>
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col xs={12}>
                                <Grid
                                    columns={columns}
                                    items={this.state.items}
                                    height={275}
                                    rowKey="sponsorId"
                                    className="table-condensed"
                                    onChange={this.onGridChange}
                                    name="default" />
                            </Col>
                        </Row>
                    </React.Fragment>
                }
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={this.save}>Save</Button>
                    <Button onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default SponsorSelectionPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/paypalInvoiceSetup/paypalInvoiceInfo/SponsorSelectionPopUp.js